(function ($) {
  "use strict";

  const toggleFilters = () => {
    $("[data-filter-toggle]").on("click", () => {
      $("[data-filter-toggle]").toggleClass("is-active");
    });
  };

  $(document).ready(function () {
    if ($("body").hasClass("node--type-product-overview")) {
      toggleFilters();
    }
  });
})(jQuery);
